import React from 'react';
import { Card } from 'primereact/card';

import Conversations from './Conversations';
import InputContainer from './InputContainer';
import Sidebar from 'modules/messages/SecureMessages/Sidebar/Sidebar';

function MessageContainer({ messageDetails, showSideBar, hasPermission, addUserHandler, fetchCaseMessageDetails }) {
  return (
    <div className="inner-conversation pb-3">
      <div className="row mb-5">
        <div className={showSideBar ? 'col-md-8 col-sm-12' : 'col-md-12'}>
          <Card className="card-bg">
            <Conversations messageDetails={messageDetails} fetchCaseMessageDetails={fetchCaseMessageDetails} />
            <InputContainer
              messageDetails={messageDetails}
              hasPermission={hasPermission}
              addUserHandler={addUserHandler}
              fetchCaseMessageDetails={fetchCaseMessageDetails}
            />
          </Card>
        </div>
        {messageDetails && showSideBar && (
          <div className="col-md-4 col-sm-12 p-0">
            <div className="card-bg p-2 sidebar-height" style={{ display: 'flex', flexDirection: 'column', position: 'sticky', top: 0 }}>
              <Sidebar messageDetails={messageDetails} hasPermission={hasPermission} className="h-100" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MessageContainer;
